import { render } from "./SlotScroll.vue?vue&type=template&id=f5f30634&scoped=true"
import script from "./SlotScroll.vue?vue&type=script&lang=js"
export * from "./SlotScroll.vue?vue&type=script&lang=js"

import "./SlotScroll.vue?vue&type=style&index=0&id=f5f30634&scoped=true&lang=css"

import exportComponent from "E:\\项目\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f30634"]])

export default __exports__